import type { StorageObjectGroupEventListApiData } from '@navio/nsdk';
import { filterUnitFor, useFilterUnits, withUrlPrefix } from 'noddi-ui-web';

type StorageObjectGroupEventQuery = Omit<
  NonNullable<StorageObjectGroupEventListApiData['query']>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search'
>;

const unit = filterUnitFor<StorageObjectGroupEventQuery>();

// Undone events are left out like deleted ones; this shows them, struck through.
const showUndoneFilter = unit.boolean('includeRetracted', {
  title: 'Show undone events',
  description: 'Struck through, with who undid them and why',
  onlyTrue: true
});

export const useStorageObjectGroupEventFilters = (urlPrefix?: string) =>
  useFilterUnits([urlPrefix ? withUrlPrefix(urlPrefix, showUndoneFilter) : showUndoneFilter]);
